/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of the application.
 */
export enum AppType {
  AppTypeCompose = 'compose',
  AppTypeQuadlet = 'quadlet',
  AppTypeContainer = 'container',
  AppTypeHelm = 'helm',
  AppTypeVm = 'vm',
}
